import CardLayout from './CardLayout';
import CardLayoutAlwaysExcerpt from './CardLayout.cdc_posts_always_excerpt';
import { withFeatureBranch } from '../../../../redux/flags';
export default withFeatureBranch({
    cdc_posts_always_excerpt: CardLayoutAlwaysExcerpt,
})(CardLayout);
//# sourceMappingURL=index.js.map